import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faStopCircle } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Button, Checkbox, ListItem, Text,
} from '@domain-group/suit-theme'

import { useNumericParams } from '@domain-group/react-hooks'

import { handleCallbackAction } from '@domain-group/javascript-utils'

import useCampaignPortal from '@hooks/useCampaignPortal'

import { PortalModel } from '@models/types'

interface AvailablePortalListItemProps {
  portal: PortalModel,
}

const AvailablePortalListItem = (props: AvailablePortalListItemProps) => {
  const { portal } = props
  const { id: portalId, title } = portal

  const { campaignId } = useNumericParams()

  const {
    callbacks: {
      createCampaignPortal: createFn,
    },
  } = useCampaignPortal()

  const createCampaignPortalPayload = {
    callbacks: {
      action: createFn,
    },
    entityParams: {
      campaign_id: campaignId,
      portal_id: portalId,
    },
    toastText: 'Portal Enabled',
  }

  return (
    <ListItem
      boxProps={{
        alignItems: 'center',
        borderBottom: '1px dashed',
        padding: 'large',
      }}
      disableHover
    >
      <Checkbox style={{ cursor: 'auto' }} iconDefault={faStopCircle} />

      <Box flexDirection="column">
        <Text fontSize="small">{title || `Portal #${portalId}`}</Text>

        <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="small">
          Not syncing
        </Text>
      </Box>

      <Box flexDirection="column" justifyContent="flex-end" marginLeft="auto" textAlign="right" width="auto">
        <Button
          buttonStyle="secondaryUtility"
          icon={<FontAwesomeIcon icon={faPlus} />}
          onClick={() => handleCallbackAction(createCampaignPortalPayload)}
          size="small"
        >
          Enable
        </Button>
      </Box>
    </ListItem>
  )
}

export default AvailablePortalListItem
